<template>
  <div>
    <ErrorMessage
      v-show="errorMessage != null && errorMessage != ''"
      :msg="errorMessage"
    ></ErrorMessage>
    <div class="select_box">
      <input
        v-if="inputShow"
        v-model="selectValue"
        class="select_input_box form-control"
        type="text"
      />
      <select
        :value="selectindex"
        class="form-select page-body-font pt-0 pb-0"
        style="height: 25px"
        :disabled="disabled"
        @click="select"
        @change="change($event.target.value)"
        @input="$emit('input', $event.target.value)"
      >
        <option v-for="opt in selectOption" :key="opt.name" :value="opt.id">
          {{ opt.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import ErrorMessage from './../ErrorMessage.vue'
export default {
  name: 'InputSelectTENew',
  components: { ErrorMessage },
  props: {
    errorMessage: String,
    value: String,
    hidden: Boolean,
    options: Array,
    required: Boolean,
    disabled: Boolean,
    inputShow: Boolean
  },
  data() {
    return {
      errorStyle: '',
      selectValue: '',
      selectOption: [{ id: '0', name: 'ーー' }],
      selectindex: 999
    }
  },
  watch: {
    value(v) {},
    selectValue(selectValue) {
      if (this.inputShow === true) {
        this.selectindex = 999
      }
    },
    errorMessage: {
      immediate: true,
      handler(value) {
        if (value !== null && value !== '') {
          this.errorStyle = 'errorStyle'
        } else {
          this.errorStyle = ''
        }
      }
    }
  },
  created() {
    this.selecList(this.options)
  },
  methods: {
    selecList(list) {
      list.forEach((value, i) => {
        this.selectOption[i + 1] = value
        this.selectValue = value.name
        this.selectindex = this.value
      })
    },
    select() {
      this.$emit('select')
    },
    change(e) {
      this.selectValue = this.selectOption[e].name
    }
  }
}
</script>

<style scoped lang="scss">
.select_box {
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  .select_input_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 80%;
    height: 100%;
    border: 0;
  }
  select {
    border: none;
  }
}
</style>
